import image1 from "../assets/image1.jpg";
import image2 from "../assets/image2.jpg";
import image3 from "../assets/image3.jpg";
import image4 from "../assets/image4.jpg";
import image5 from "../assets/image5.jpg";
import image6 from "../assets/image6.jpg";
import image7 from "../assets/image7.jpg";

export const items = [
  { name: "image1", icon: image1 },
  { name: "image2", icon: image2 },
  { name: "image3", icon: image3 },
  { name: "image4", icon: image4 },
  { name: "image5", icon: image5 },
  { name: "image6", icon: image6 },
];
